/**
 * German-locale date formatting (NF-021). One shared Intl instance per format;
 * inputs are ISO-8601 strings from the API. Invalid/absent values render as an
 * em-dash placeholder rather than "Invalid Date".
 */
const PLACEHOLDER = "-";

const dateTimeFormat = new Intl.DateTimeFormat("de-DE", {
  dateStyle: "medium",
  timeStyle: "short",
});

const dateFormat = new Intl.DateTimeFormat("de-DE", {
  dateStyle: "medium",
});

function parse(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDateTime(iso: string | null | undefined): string {
  const d = parse(iso);
  return d ? dateTimeFormat.format(d) : PLACEHOLDER;
}

export function formatDate(iso: string | null | undefined): string {
  const d = parse(iso);
  return d ? dateFormat.format(d) : PLACEHOLDER;
}

/** Short, human-glanceable form of a UUID (no user-name lookup exists yet). */
export function shortId(id: string | null | undefined): string {
  if (!id) return PLACEHOLDER;
  return id.slice(0, 8);
}
